import { Typography } from '@mui/material';

interface DocumentTypeDescriptionProps {
  description: string | null | undefined;
}

export function DocumentTypeDescription({ description }: DocumentTypeDescriptionProps) {
  if (!description) {
    return null;
  }
  return (
    <Typography
      variant="body2"
      data-testid="document-type-description"
      sx={{ color: 'text.secondary' }}
    >
      {description}
    </Typography>
  );
}
